import { useContext, useRef } from "react"
import {
  createStyles,
  createCSS,
  Styles,
  createElement,
  forwardRef,
} from "@design-system/styled-system"
import { useMergeRefs, useElementLayout } from "@design-system/hooks"
import { ViewProps } from "./types"
import { TextAncestorContext } from "./TextAncestorContext"

const classes = createCSS({
  view: {
    alignItems: "stretch",
    border: "0 solid black",
    boxSizing: "border-box",
    display: "flex",
    flexBasis: "auto",
    flexDirection: "column",
    flexShrink: 0,
    margin: 0,
    minHeight: 0,
    minWidth: 0,
    padding: 0,
    position: "relative",
    zIndex: 0,
  },
})

const classList = [classes.view]

const styles = createStyles({
  inline: {
    display: "inline-flex",
  },
})

export const View = forwardRef<ViewProps, "div">((props, forwardedRef) => {
  const hasTextAncestor = useContext(TextAncestorContext)
  const hostRef = useRef(null)
  const { style: styleProp, onLayout, ...others } = props
  const style = Styles.compose(hasTextAncestor && styles.inline, styleProp)

  useElementLayout<HTMLDivElement>(hostRef, onLayout)

  const viewProps = {
    ...others,
    classList,
    style,
    ref: useMergeRefs<"div">(hostRef, forwardedRef),
  }

  return createElement("div", viewProps)
})

View.displayName = "View"
